import styles from '../../index.module.scss';
import type { SmartImportChat } from '../useSmartImportChat';

export default function TemplateCard({ chat }: { chat: SmartImportChat }) {
	if (!chat.templateMatch) return null;
	return (
		<div className={styles['action-card']}>
			<div className={styles['action-card__summary']}>
				&ldquo;{chat.templateMatch.template.name}&rdquo; matches {chat.templateMatch.overlapCount} of{' '}
				{chat.templateMatch.totalColumns} columns.
			</div>
			<div className={styles['action-card__buttons']}>
				<button type="button" className={styles['action-card__confirm']} onClick={chat.applyTemplate}>
					Apply template
				</button>
				<button type="button" className={styles['action-card__cancel']} onClick={chat.declineTemplate}>
					Use auto-detected mapping
				</button>
			</div>
		</div>
	);
}
